import { formatDate } from '@angular/common';
import { effect, ElementRef, EventEmitter, input, model, NgZone } from '@angular/core';
import { Store } from '@ngrx/store';
import { Marked } from 'marked';
import { lastValueFrom } from 'rxjs/internal/lastValueFrom';
import { deleteAIEventSummary, setAIEventSummary, } from 'ChartApp/ts/apps/fund-chart/state/reducers/ai-summary-events/ai-summary-events.actions';
import { CANNOT_ANSWER_RESPONSE, INCOMPLETE_MARKDOWN_LINK_REGEX } from 'AIChatApp/constants/ai-chat.constant';
import { FUND_CHART_AI_CALC_NAME_MAP } from 'ChartApp/ts/apps/fund-chart/constants';
import { AGENT_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { AIChatService } from 'AIChatApp/services/ai-chat.service';
import { FundChartAISummaryService } from 'ChartApp/ts/apps/fund-chart/services/fund-chart-ai-summary.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { AIStreamingService } from 'NewAngular/services/ai-streaming.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { UtilsService } from 'NewAngular/services/core/utils.service';
import { SingleDatePickerModule } from 'NewAngular/features/components/date-controls/single-date-picker/single-date-picker.module';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/ai-streaming.service";
import * as i2 from "NewAngular/services/core/utils.service";
import * as i3 from "ChartApp/ts/apps/fund-chart/services/fund-chart-ai-summary.service";
import * as i4 from "AIChatApp/services/ai-chat.service";
import * as i5 from "NewAngular/services/core/urls.service";
import * as i6 from "@ngrx/store";
import * as i7 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i8 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/components/date-controls/single-date-picker/single-date-picker.component";
import * as i10 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i11 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
function FundChartAISummaryModalComponent_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", ctx_r0.securityId(), " - ", ctx_r0.calcName);
} }
function FundChartAISummaryModalComponent_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.securityId());
} }
function FundChartAISummaryModalComponent_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.dateRangeLabel);
} }
function FundChartAISummaryModalComponent_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "button", 11);
    i0.ɵɵlistener("click", function FundChartAISummaryModalComponent_Conditional_7_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.deleteEvent()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "div", 10)(4, "button", 13);
    i0.ɵɵlistener("click", function FundChartAISummaryModalComponent_Conditional_7_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.closeModal()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(5, "svg", 14);
    i0.ɵɵelementEnd()();
} }
function FundChartAISummaryModalComponent_Conditional_10_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.moduleErrorMessage, " ");
} }
function FundChartAISummaryModalComponent_Conditional_10_Conditional_2_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, " Summarizing news and events... ");
} }
function FundChartAISummaryModalComponent_Conditional_10_Conditional_2_Conditional_1_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵlistener("click", function FundChartAISummaryModalComponent_Conditional_10_Conditional_2_Conditional_1_Conditional_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r0 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r0.convertToAIChat()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 19);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(2, "span", 20);
    i0.ɵɵtext(3, "Ask Follow Up Question");
    i0.ɵɵelementEnd()();
} }
function FundChartAISummaryModalComponent_Conditional_10_Conditional_2_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelement(1, "div", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(2, FundChartAISummaryModalComponent_Conditional_10_Conditional_2_Conditional_1_Conditional_2_Template, 4, 0, "button", 17);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("id", ctx_r0.scrollContainerId);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.text, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.streaming ? 2 : -1);
} }
function FundChartAISummaryModalComponent_Conditional_10_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, FundChartAISummaryModalComponent_Conditional_10_Conditional_2_Conditional_0_Template, 1, 0)(1, FundChartAISummaryModalComponent_Conditional_10_Conditional_2_Conditional_1_Template, 3, 3);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r0.loading ? 0 : 1);
} }
function FundChartAISummaryModalComponent_Conditional_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵconditionalCreate(1, FundChartAISummaryModalComponent_Conditional_10_Conditional_1_Template, 1, 1)(2, FundChartAISummaryModalComponent_Conditional_10_Conditional_2_Template, 2, 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.moduleErrorMessage ? 1 : 2);
} }
function FundChartAISummaryModalComponent_Conditional_11_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p", 21);
    i0.ɵɵtext(1, "Click on chart or edit dates below to change the time frame:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 22)(3, "div", 23)(4, "div", 24);
    i0.ɵɵtext(5, "Start Date\u00A0 ");
    i0.ɵɵelementStart(6, "span", 25);
    i0.ɵɵlistener("click", function FundChartAISummaryModalComponent_Conditional_11_Template_span_click_6_listener() { i0.ɵɵrestoreView(_r4); i0.ɵɵnextContext(); const helpModal_r5 = i0.ɵɵreference(13); return i0.ɵɵresetView(helpModal_r5.openModal("fund_chart_ai_summary_start_date")); });
    i0.ɵɵtext(7, "(?)");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "ycn-single-date-picker", 26);
    i0.ɵɵlistener("dateChangeHandler", function FundChartAISummaryModalComponent_Conditional_11_Template_ycn_single_date_picker_dateChangeHandler_8_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.setStartDate($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 23)(10, "div", 24);
    i0.ɵɵtext(11, "End Date\u00A0 ");
    i0.ɵɵelementStart(12, "span", 25);
    i0.ɵɵlistener("click", function FundChartAISummaryModalComponent_Conditional_11_Template_span_click_12_listener() { i0.ɵɵrestoreView(_r4); i0.ɵɵnextContext(); const helpModal_r5 = i0.ɵɵreference(13); return i0.ɵɵresetView(helpModal_r5.openModal("fund_chart_ai_summary_end_date")); });
    i0.ɵɵtext(13, "(?)");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "ycn-single-date-picker", 27);
    i0.ɵɵlistener("dateChangeHandler", function FundChartAISummaryModalComponent_Conditional_11_Template_ycn_single_date_picker_dateChangeHandler_14_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.setEndDate($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "div", 28)(16, "button", 29);
    i0.ɵɵlistener("click", function FundChartAISummaryModalComponent_Conditional_11_Template_button_click_16_listener() { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.submit()); });
    i0.ɵɵtext(17, "Submit");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("selectedDate", ctx_r0.startDate())("appendToBody", true);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("selectedDate", ctx_r0.endDate())("appendToBody", true);
} }
/**
 * Fund Chart AI Summary Modal Component
 *
 * This is a component for AI-generated summaries of events of a security calc in a date range.
 *
 */
export class FundChartAISummaryModalComponent {
    constructor(aiStreamingService, utilsService, fundChartAISummaryService, aiChatService, urlsService, store, ngZone, el, featureService) {
        this.aiStreamingService = aiStreamingService;
        this.utilsService = utilsService;
        this.fundChartAISummaryService = fundChartAISummaryService;
        this.aiChatService = aiChatService;
        this.urlsService = urlsService;
        this.store = store;
        this.ngZone = ngZone;
        this.el = el;
        this.featureService = featureService;
        this.streamedSummarySaved = new EventEmitter();
        this.isQuestionAsked = new EventEmitter();
        this.isOpen = model.required(...(ngDevMode ? [{ debugName: "isOpen" }] : []));
        this.securityId = input.required(...(ngDevMode ? [{ debugName: "securityId" }] : []));
        this.securityName = input.required(...(ngDevMode ? [{ debugName: "securityName" }] : []));
        this.securityType = input.required(...(ngDevMode ? [{ debugName: "securityType" }] : []));
        this.securityTopTenHoldings = input.required(...(ngDevMode ? [{ debugName: "securityTopTenHoldings" }] : []));
        this.securitySectors = input.required(...(ngDevMode ? [{ debugName: "securitySectors" }] : []));
        this.securityAssetClasses = input.required(...(ngDevMode ? [{ debugName: "securityAssetClasses" }] : []));
        this.calc = input.required(...(ngDevMode ? [{ debugName: "calc" }] : []));
        this.startDate = model.required(...(ngDevMode ? [{ debugName: "startDate" }] : []));
        this.endDate = model.required(...(ngDevMode ? [{ debugName: "endDate" }] : []));
        this.moduleErrorMessage = '';
        this.dateRangeLabel = '';
        this.text = '';
        this.loading = false;
        this.streaming = false;
        this.marked = new Marked();
        this.scrollContainerId = 'stock-events-scroll';
        this.questionAsked = false;
        this.calcName = '';
        this.prompt = '';
        effect(() => {
            if (this.isOpen()) {
                this.streaming = false;
                this.updateDateRangeLabel();
            }
            const calc = this.calc();
            this.calcName = calc ? FUND_CHART_AI_CALC_NAME_MAP[calc] : '';
        });
    }
    closeModal() {
        this.isOpen.update((_) => false);
        this.questionAsked = false;
        this.isQuestionAsked.emit(this.questionAsked);
    }
    setStartDate(date) {
        this.startDate.update((_) => date);
    }
    setEndDate(date) {
        this.endDate.update((_) => date);
    }
    deleteEvent() {
        this.store.dispatch(deleteAIEventSummary({
            calc: this.calc(),
            startDate: formatDate(this.startDate(), 'MM-dd-yyyy', 'en-US'),
            endDate: formatDate(this.endDate(), 'MM-dd-yyyy', 'en-US'),
            securityId: this.securityId(),
        }));
        this.closeModal();
    }
    submit() {
        this.text = '';
        this.questionAsked = true;
        this.isQuestionAsked.emit(this.questionAsked);
        this.updateDateRangeLabel();
        const startDate = formatDate(this.startDate(), 'MM-dd-yyyy', 'en-US');
        const endDate = formatDate(this.endDate(), 'MM-dd-yyyy', 'en-US');
        const calc = this.calc();
        const securityId = this.securityId();
        this.store.dispatch(setAIEventSummary({ calc, startDate, endDate, securityId }));
    }
    async saveSummary() {
        const startDate = formatDate(this.startDate(), 'MM-dd-yyyy', 'en-US');
        const endDate = formatDate(this.endDate(), 'MM-dd-yyyy', 'en-US');
        const streamedAISummary = {
            calc: this.calc(),
            securityId: this.securityId(),
            textContent: this.text,
            prompt: this.prompt,
            startDate,
            endDate,
        };
        this.streamedSummarySaved.emit(streamedAISummary);
        await lastValueFrom(this.fundChartAISummaryService.saveSummary(this.calc(), startDate, endDate, this.securityId(), this.text, this.prompt));
    }
    setText(text, prompt) {
        this.questionAsked = true;
        this.isQuestionAsked.emit(this.questionAsked);
        this.text = text;
        this.prompt = prompt;
    }
    scrollResponseIntoView() {
        const scrollContainer = this.el.nativeElement.querySelector(`#${this.scrollContainerId}`);
        if (scrollContainer) {
            scrollContainer.scroll({ behavior: 'smooth', top: scrollContainer.scrollHeight });
        }
    }
    streamSecurityEvents() {
        this.prompt = '';
        this.loading = true;
        this.streaming = true;
        let first = true;
        let rawResponse = '';
        this.moduleErrorMessage = '';
        const handlers = {
            token: async (token) => {
                if (first) {
                    this.text = '';
                    first = false;
                    this.ngZone.run(() => {
                        this.loading = false;
                    });
                }
                rawResponse += token;
                // Replace all incomplete Markdown links with a placeholder
                const updatedRawResponse = rawResponse.replace(INCOMPLETE_MARKDOWN_LINK_REGEX, '*Creating Link...*');
                // Convert any Markdown formatting in the response to HTML.
                // OpenAI chat models are specifically trained to output Markdown,
                // so instructing the model to output HTML instead does not work as well.
                const formattedResponse = await this.marked.parse(updatedRawResponse);
                this.ngZone.run(() => {
                    this.text = formattedResponse;
                    this.scrollResponseIntoView();
                });
            },
            error: () => {
                this.loading = false;
                this.streaming = false;
                this.moduleErrorMessage = 'Error searching for security events.';
            },
            done: async () => {
                this.streaming = false;
                this.text = await this.marked.parse(rawResponse);
                this.scrollResponseIntoView();
                this.saveSummary();
            },
        };
        const queryParams = {
            startDate: formatDate(this.startDate(), 'MM-dd-yyyy', 'en-US'),
            endDate: formatDate(this.endDate(), 'MM-dd-yyyy', 'en-US'),
            securitySymbol: this.securityId(),
            securityName: this.securityName(),
            securityType: this.securityType(),
            securityTopTenHoldings: this.securityTopTenHoldings(),
            securitySectors: this.securitySectors(),
            securityAssetClasses: this.securityAssetClasses(),
        };
        const url = this.utilsService.addQueryParams('security_events', queryParams);
        const customHandlers = {
            prompt: (event) => {
                this.prompt = event.data;
            },
        };
        this.aiStreamingService.stream(url, handlers, customHandlers);
    }
    convertToAIChat() {
        if (this.text.includes(CANNOT_ANSWER_RESPONSE)) {
            return;
        }
        if (this.featureService.userHasFeatures([AGENT_FEATURE])) {
            const calcLabel = this.calcName || this.calc();
            const startDate = formatDate(this.startDate(), 'MMMM dd, y', 'en-US');
            const endDate = formatDate(this.endDate(), 'MMMM dd, y', 'en-US');
            const userPrompt = `Explain the ${calcLabel} movements of ${this.securityName()} ` +
                `(${this.securityId()}) from ${startDate} to ${endDate}.`;
            window.location.href = this.urlsService.getUrl(this.urlsService.AGENT.PAGE, undefined, { userPrompt });
            return;
        }
        const createConversation = {
            conversationId: null,
            prompt: this.prompt,
            response: this.text,
            topics: ['web_search'],
            sources: [],
            tools: [],
        };
        this.aiChatService.savePromptAndResponseToConversation(createConversation).subscribe(({ conversationId }) => {
            const AIChatAppURL = this.urlsService.AI_CHAT.CHAT;
            window.location.href = `${this.urlsService.getUrl(AIChatAppURL)}?conversationId=${conversationId}`;
        });
    }
    updateDateRangeLabel() {
        this.dateRangeLabel = `${this.formatLabelDate(this.startDate())} - ${this.formatLabelDate(this.endDate())}`;
    }
    formatLabelDate(date) {
        return `${formatDate(date, 'MMMM dd, y', 'en-US')}`;
    }
}
FundChartAISummaryModalComponent.ɵfac = function FundChartAISummaryModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartAISummaryModalComponent)(i0.ɵɵdirectiveInject(i1.AIStreamingService), i0.ɵɵdirectiveInject(i2.UtilsService), i0.ɵɵdirectiveInject(i3.FundChartAISummaryService), i0.ɵɵdirectiveInject(i4.AIChatService), i0.ɵɵdirectiveInject(i5.UrlsService), i0.ɵɵdirectiveInject(i6.Store), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i7.FeatureService)); };
FundChartAISummaryModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FundChartAISummaryModalComponent, selectors: [["ycn-fund-chart-ai-summary-modal"]], inputs: { isOpen: [1, "isOpen"], securityId: [1, "securityId"], securityName: [1, "securityName"], securityType: [1, "securityType"], securityTopTenHoldings: [1, "securityTopTenHoldings"], securitySectors: [1, "securitySectors"], securityAssetClasses: [1, "securityAssetClasses"], calc: [1, "calc"], startDate: [1, "startDate"], endDate: [1, "endDate"] }, outputs: { streamedSummarySaved: "streamedSummarySaved", isQuestionAsked: "isQuestionAsked", isOpen: "isOpenChange", startDate: "startDateChange", endDate: "endDateChange" }, decls: 14, vars: 6, consts: [["helpModal", ""], [1, "window", "width-300", 2, "top", "-50px", "right", "0px"], [1, "window-header"], [1, "window-title"], [1, "text-bold"], [1, "text-small", "text-gray-30"], [1, "window-controls"], [1, "window-body"], [1, "window-content"], [1, "text-gray-50", "mb-1"], [1, "window-control"], ["type", "button", 1, "btn", "btn-xs", "btn-circle", "btn-transparent2", 3, "click"], ["ycnIcon", "", "name", "icon-delete"], ["type", "button", 1, "btn", "btn-xs", "btn-circle", "btn-transparent2", "btn-close", 3, "click"], ["ycnIcon", "", "name", "icon-close"], [3, "id"], [3, "innerHTML"], ["ycnTooltip", "", "tooltipTitle", "Open in AI Tool", "tooltipPlacement", "left", 1, "tile", "width-auto"], ["ycnTooltip", "", "tooltipTitle", "Open in AI Tool", "tooltipPlacement", "left", 1, "tile", "width-auto", 3, "click"], ["ycnIcon", "", "name", "icon-sparkle"], [1, "text-nowrap"], [1, "mb-1"], [1, "row", "narrow-gutters", "align-items-end"], [1, "col"], [1, "form-label", "form-label-thin", "pb-1", "text-nowrap"], [1, "help-toggler", "text-black", 3, "click"], [3, "dateChangeHandler", "selectedDate", "appendToBody"], [1, "dropdown", "menu-right", 3, "dateChangeHandler", "selectedDate", "appendToBody"], [1, "col-auto"], [1, "btn", "btn-primary", 3, "click"]], template: function FundChartAISummaryModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3);
        i0.ɵɵconditionalCreate(3, FundChartAISummaryModalComponent_Conditional_3_Template, 2, 2, "div", 4)(4, FundChartAISummaryModalComponent_Conditional_4_Template, 2, 1, "div", 4);
        i0.ɵɵconditionalCreate(5, FundChartAISummaryModalComponent_Conditional_5_Template, 2, 1, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵconditionalCreate(7, FundChartAISummaryModalComponent_Conditional_7_Template, 6, 0);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "div", 7)(9, "div", 8);
        i0.ɵɵconditionalCreate(10, FundChartAISummaryModalComponent_Conditional_10_Template, 3, 1, "div", 9)(11, FundChartAISummaryModalComponent_Conditional_11_Template, 18, 4);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(12, "ycn-help-modal", null, 0);
    } if (rf & 2) {
        i0.ɵɵstyleProp("display", !ctx.isOpen() ? "none" : "flex");
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.calcName ? 3 : 4);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.questionAsked ? 5 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(!ctx.streaming ? 7 : -1);
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.questionAsked ? 10 : 11);
    } }, dependencies: [IconModule, i8.IconDirective, SingleDatePickerModule, i9.SingleDatePickerComponent, HelpModalModule, i10.HelpModalComponent, TooltipModule, i11.TooltipDirective], encapsulation: 2 });
